import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Updated import path
import { Button } from '../common/Button';
import dashboardImage from '../../assets/dashboard.png';

export const Hero = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth(); // Updated to use isAuthenticated instead of user

    const handleGetStarted = () => {
        if (isAuthenticated) {
            navigate('/dashboard');
        } else {
            navigate('/login');
        }
    };

    return (
        <section className="py-20 bg-gradient-to-r from-blue-500 to-indigo-600 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between">
                    <div className="md:w-1/2 mb-10 md:mb-0">
                        <h2 className="text-4xl md:text-5xl font-bold mb-4">
                            Take Control of Your Subscriptions
                        </h2>
                        <p className="text-xl mb-8">
                            Track, manage, and optimize your subscriptions in one place. Save money and never miss a payment again.
                        </p>
                        <Button 
                            variant="secondary" 
                            size="lg" 
                            className="hover:bg-gray-100"
                            onClick={handleGetStarted}
                        >
                            Start Tracking Free
                        </Button>
                    </div>
                    <div className="md:w-1/2">
                        <img
                            src={dashboardImage}
                            alt="Dashboard Preview"
                            className="rounded-lg shadow-xl"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};